export default {
  playable: {
    title: '可玩',
    download: '可玩下载/推送',
    notes: '(Mintegral推送不限制)',
    describe: '(可用/总购买)',
    notesTip: '不限制Mintegral渠道素材推送次数',
  },
  video: {
    title: '视频',
    export: '视频导出',
    clip: '智能分镜',
    subtitle: '智能识别字幕',
    speech: '智能配音',
    clone: '克隆音色数',
  },
  expireDate: '到期时间：',
  expireAfter: '还剩{days}天',
  expired: '您的订阅已过期',
  current: {
    remaining: '套餐内',
  },
  additional: {
    quota: '叠加包',
  },
  unlimited: '不限制',
  plan: {
    tips: '(可用/已购)',
  },
  online: {
    storage: '在线储存空间',
    describe: '(已使用/总空间)',
    exceedPrompt: '若空间已满，将无法新建和编辑项目，请及时扩容或清理。',
  },
  subscriber: '正式',
  trial: '试用',
  individual: '个人',
  enterprise: '企业',
  refresh: {
    time: '套餐内刷新时间',
  },
  details: {
    title: '余量详情',
  },
  unit: {
    coin: '点数',
    time: '次',
    item: '条',
  },
  usage: {
    videoCredit: {
      unit: {
        description:
          '不同AI服务消耗点数<br />- 视频AI消除：根据消除视频时长计算，45点/秒 <br />- 语音识别：根据待识别视频或音频时长计算，5点/分钟 <br />- 智能分镜：根据待检测视频时长计算，20点/分钟 <br />- 语音克隆：每克隆一个声音音色，消耗240点 <br />- 视频导出：根据导出视频时长计算，15点/分钟<br />- 链接生图：根据生成图片数量计算，15 点/张',
      },
    },
  },
  subscribe: {
    now: '立即续订',
    tips: '请联系销售进行续订。',
    overtime: '您的订阅已到期，请联系销售进行续订',
    overtime2: '您的订阅已到期，请续订',
    free: {
      tips: '您尚未开通服务，立即申请开通免费试用吧！',
    },
    title: '续订',
    otherTitle: '额度不足',
    accountBalance: '账户余额',
    desc: '请联系销售进行续订。或者发送邮件至 <a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a>，并且备注你的Playturbo用户名。',
    otherDesc:
      '请联系销售进行购买。或者发送邮件至 <a href="mailto:sales@mindworks-creative.com">sales@mindworks-creative.com</a>，并且备注你的Playturbo用户名。',
    ok: '好的',
  },
}
